export const FeatureFlags = {
  BATCH_TRACING_REPORT: 'batch_tracing_report',
  // Unlike BATCH_TRACING_REPORT, this one is ALSO real backend
  // enforcement (AB#6095): the same FeatureFlag row (name=
  // "ms_teams_notifications") is checked live by the organizations
  // service's MsTeamsNotificationsFeatureEnabled permission and
  // resolve_audience() -- not a session snapshot, a live DB check inside
  // the service that owns the model. So this flag genuinely gates the API
  // too, not just what this UI shows.
  MS_TEAMS_NOTIFICATIONS: 'ms_teams_notifications',
  // The benchmark section of a report template (AB#6041). Not UI only:
  // mbai-pm-core refuses its benchmark endpoints (403) to a user without it,
  // and organizations admins assign it per organization or per user. Without
  // it the UI never offers, renders or opens a benchmark section -- not in the
  // template editor, not in a report -- so nothing calls those endpoints.
  BENCHMARK_SECTION: 'benchmark_section',
  // Program guidelines (AB#6041). Not UI only: mbai-pm-core refuses the
  // program-guideline endpoints (403) to a user without it; organizations
  // admins assign it per organization or per user. Without it the Programs
  // table has no Guideline column and Alpinist is not pointed at a guideline.
  PROGRAM_GUIDELINES: 'program_guidelines',
  // The new experience (AB#6639): the v2 shell (src/v2) takes every signed-in
  // page at every width, unless this browser switched back to classic. UI only:
  // the v2 API answers the same with or without it. Each native page has its
  // own flag (`ui_v2_page_<name>`), read by the v2 app itself.
  UI_V2_EXPERIENCE: 'ui_v2_experience',
  // Shop-floor display screens (AB#6756): pairing a TV or tablet to a
  // dashboard by QR code. Not UI only: mbai-pm-core refuses the display-screens
  // endpoints (pair, list, revoke) to a user without it. Without it the Share
  // dialog has no Screens section, Settings has no Screens tab and
  // /display/pair sends the person home. A screen already paired keeps showing
  // its dashboard: its session is not a person's.
  DISPLAY_SCREENS: 'display_screens',
  // Alpinist stop & steer (AB#6760): a Stop button, and messages sent while a
  // run works are taken into it. UI only -- the backend runs one turn per
  // conversation and accepts a stop with or without it.
} as const

/*
 * TASKS, AUTOMATIONS and REPORTING were removed with AB#5869.
 *
 * They gated the UI only — mbai-pm-core reads `request.feature_flags` nowhere,
 * so the endpoints were always reachable by any authenticated member of a
 * tenant. Those three screens are now gated on the permissions the
 * organizations catalog grants (`useHasPermission`), which the server actually
 * enforces, so the flag was the last thing pretending to be access control.
 *
 * The rows still exist in the organizations database and can be deleted once
 * this ships; nothing reads them.
 */

export type FeatureFlag = (typeof FeatureFlags)[keyof typeof FeatureFlags]
